import React from 'react';
import Carousel from '../carousel/carousel';
import { NavLink } from "react-router-dom";

class Mantra_3_A1_Canvas extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {

        const { yourFriendName, reasonOn1, reasonOn2, reasonOn3 } = this.props;

        return (
            <section  id={"canvas_generate_" + this.props.module_name} className="canvas_section mantra3_canvas setdiv_canvas ">
                <div className="mantra3_a1 mantra3_a1_back">
                    <h3 className="mantra3_a1_name">Dear,</h3>
                    <h3 className="mantra3_a1_name2">{yourFriendName}</h3>
                </div>
                <div className="m3_em_para">
                    <p className="m3_canvas_para">Here are three things about you that make me laugh!
                    <span className="m3_em_wrp">
                        <img src="/assets/img/em1.png"/>
                        <img src="/assets/img/em2.png"/>
                        <img src="/assets/img/em3.png"/>
                    </span>
                    </p>
                   
                </div>
                <ol className="mantra_ol" type="1">
                    <li><span>1.</span>{reasonOn1}</li>
                    <li><span>2.</span>{reasonOn2}</li>
                    <li><span>3.</span>{reasonOn3}</li>
                </ol>
                <p className="m3_canvas_para2">Wishing you Best of luck for the exam!</p>
            </section>
        )
    }
}

export default Mantra_3_A1_Canvas;